import React from "react";
import { Row, Col } from "react-bootstrap";
import { RBSModal } from "../../base/rbs_components/RBSModal.tsx";
import { RBSTextField } from "../../base/rbs_components/RBSTextField.tsx";
import { RBSDropdown } from "../../base/rbs_components/RBSDropdown.tsx";
import type { InputStateControl } from "../../base/utils/InputStateControl.tsx";
import {TextfieldInputTypes, type UserLanguages} from "../../base/Settings.tsx";
import { ValidationSchemes, LabelTextMessageTypes } from "../../base/Settings.tsx";
import { getLabelTextMessage } from "../../base/utils/GeneralUtilities.tsx";
import {FormulaTypeEnum} from "../../base/Settings.tsx";
import type {Formula} from "../../base/ui_general/GeneralInterfaces.tsx";


//TODO: Add multi-language support


/**
 * Props for the FormulaEditModal component.
 */
interface FormulaEditModalProps {
    /** Whether the modal is visible. */
    show: boolean;
    /** The formula object to edit. */
    formula: Formula;
    /** Callback when the formula is submitted. */
    onSubmit: (input: Formula) => void;
    /** Callback when the modal is closed. */
    onClose: () => void;
    /** Indicates if the current input is valid. */
    isValid: boolean;
    /** State control for form inputs. */
    inputStateControl: InputStateControl;
    /** The user's language preference. */
    user_language: UserLanguages;
}


export const FormulaEditModal: React.FC<FormulaEditModalProps> = (props: FormulaEditModalProps) => {
    const { formula, inputStateControl, user_language } = props;

    const prefill = (key: keyof Formula): string => {
        if (formula && formula[key] !== undefined && formula[key] !== null) {
            return String(formula[key]);
        }
        return "";
    };

    const headerTitle = formula ? "Update Formula" : "Create New Formula";

    return (
        <RBSModal
            show={props.show}
            header_title={headerTitle}
            show_close_button
            onClose={props.onClose}
            primary_button_label={getLabelTextMessage(LabelTextMessageTypes.SUBMIT, user_language)}
            secondary_button_label={getLabelTextMessage(LabelTextMessageTypes.CANCEL, user_language)}
            onClickSecondary={props.onClose}
            primary_button_disabled={!props.isValid}
            size="lg"
            onClickPrimary={() => {
                const updatedFormula: Formula = {
                    ...props.formula,
                    name: inputStateControl.getStringValueForKey("name") || "",
                    description: inputStateControl.getStringValueForKey("description") || "",
                    formula_type: (inputStateControl.getStringValueForKey("formula_type") as FormulaTypeEnum) || FormulaTypeEnum.STANDARD
                };

                props.onSubmit(updatedFormula);
                props.onClose();
            }}
        >
            <Row>
                <Col md={12}>
                    <RBSTextField
                        label={getLabelTextMessage(LabelTextMessageTypes.NAME, props.user_language)}
                        input_key="name"
                        prefill={prefill("name")}
                        validation_schemes={[ValidationSchemes.REQUIRED]}
                        input_state_control={inputStateControl}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <RBSDropdown
                        label="Formula Type"
                        input_key="formula_type"
                        prefill={prefill("formula_type") || FormulaTypeEnum.STANDARD}
                        items={[
                            { label: "Standard", value: FormulaTypeEnum.STANDARD}
                        ]}
                        input_state_control={inputStateControl}
                        validation_schemes={[ValidationSchemes.REQUIRED]}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <RBSTextField
                        label={getLabelTextMessage(LabelTextMessageTypes.DESCRIPTION, props.user_language)}
                        input_key="description"
                        prefill={prefill("description")}
                        validation_schemes={[ValidationSchemes.REQUIRED]}
                        input_state_control={props.inputStateControl}
                        type={TextfieldInputTypes.TEXT}
                        multiline={true}
                        style={{ minHeight: 300 }}
                    />
                </Col>
            </Row>
        </RBSModal>
    );
};